const Projects = () => {
  return (
    <a
      href="#projects"
      className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
    >
      Projects
    </a>
  );
};

export default Projects;
